import { Phone, Mail, CalendarCheck, ShieldCheck, Instagram } from "lucide-react";
import FadeIn from "./FadeIn";

const APPLICATION_URL = "https://secure.dominionlending.ca/?app=25574&lang=en";

export default function Contact({ onLead }) {
  return (
    <section id="contact" data-testid="contact-section" className="py-24 lg:py-36 bg-charcoal-800/95 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <FadeIn className="lg:col-span-7">
          <p className="gold-label mb-5">Contact</p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-ivory leading-[1.1]">
            Let's Talk About <span className="gold-text-gradient italic">Your Next Move.</span>
          </h2>
          <p className="mt-7 text-base md:text-lg text-ivory/60 font-light leading-relaxed max-w-xl">
            A conversation costs nothing and could save you thousands. Reach out directly — no call centres, no waiting rooms.
          </p>
          <p className="mt-12 font-serif text-3xl text-champagne" data-testid="contact-agent-name">Akashdeep Ghai</p>
          <p className="mt-2 text-[11px] uppercase tracking-[0.24em] text-gold/80">Mortgage Agent</p>
        </FadeIn>

        <FadeIn delay={0.15} className="lg:col-span-5">
          <div className="glass-panel rounded-md p-8 lg:p-10">
            <div className="space-y-6 pb-8 border-b border-white/10">
              <div>
                <p className="text-[11px] uppercase tracking-[0.22em] text-ivory/45 mb-2">Phone</p>
                <a
                  href="tel:+18257362193"
                  data-testid="contact-phone-link"
                  className="font-serif text-2xl text-ivory hover:text-gold transition-colors duration-300"
                >
                  (825) 736-2193
                </a>
              </div>
              <div>
                <p className="text-[11px] uppercase tracking-[0.22em] text-ivory/45 mb-2">Email</p>
                <a
                  href="mailto:akkasghai@gmail.com"
                  data-testid="contact-email-link"
                  className="font-serif text-xl text-ivory hover:text-gold transition-colors duration-300 break-all"
                >
                  akkasghai@gmail.com
                </a>
              </div>
              <div>
                <p className="text-[11px] uppercase tracking-[0.22em] text-ivory/45 mb-2">Instagram</p>
                <a
                  href="https://www.instagram.com/akashdeepmortgages"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-instagram-link"
                  className="inline-flex items-center gap-2.5 font-serif text-xl text-ivory hover:text-gold transition-colors duration-300"
                >
                  <Instagram size={16} strokeWidth={1.5} className="text-gold" />
                  @akashdeepmortgages
                </a>
              </div>
            </div>
            <div className="mt-8 space-y-3.5">
              <a
                href={APPLICATION_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-apply-btn"
                className="flex items-center justify-center gap-3 w-full px-6 py-4 text-xs tracking-[0.2em] font-semibold text-charcoal bg-gold hover:bg-champagne transition-colors duration-300 rounded-sm"
              >
                <ShieldCheck size={14} strokeWidth={1.75} /> START YOUR APPLICATION
              </a>
              <p className="text-center text-[10px] tracking-[0.14em] text-ivory/35 uppercase">
                Secure online portal · Dominion Lending Centres
              </p>
              <a
                href="tel:+18257362193"
                data-testid="contact-call-btn"
                className="flex items-center justify-center gap-3 w-full px-6 py-4 text-xs tracking-[0.2em] font-medium text-ivory border border-white/20 hover:border-gold/60 hover:text-gold transition-colors duration-300 rounded-sm"
              >
                <Phone size={14} strokeWidth={1.75} /> CALL AKASHDEEP
              </a>
              <a
                href="mailto:akkasghai@gmail.com"
                data-testid="contact-email-btn"
                className="flex items-center justify-center gap-3 w-full px-6 py-4 text-xs tracking-[0.2em] font-medium text-ivory border border-white/20 hover:border-gold/60 hover:text-gold transition-colors duration-300 rounded-sm"
              >
                <Mail size={14} strokeWidth={1.75} /> EMAIL AKASHDEEP
              </a>
              <button
                data-testid="contact-book-consultation-btn"
                onClick={() => onLead("consultation")}
                className="flex items-center justify-center gap-3 w-full px-6 py-4 text-xs tracking-[0.2em] font-medium text-ivory border border-white/20 hover:border-gold/60 hover:text-gold transition-colors duration-300 rounded-sm"
              >
                <CalendarCheck size={14} strokeWidth={1.75} /> BOOK A CONSULTATION
              </button>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
